import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { FORMAT_TEXT_COMMAND } from 'lexical'

export const Bold = ({ isBold, disabled, size }) => {
  const [editor] = useLexicalComposerContext()

  return (
    <IconButton
      toggled={isBold}
      tooltip="Bold"
      size={size}
      icon="bold-text"
      keyHint="Cmd+B"
      keyHintVisualOnly
      onClick={() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')
      }}
      disabled={disabled}
    />
  )
}
